module.exports = __webpack_public_path__ + "img/26-pacifica-alt.e872615f.png";